import React from 'react';
import { Avatar, Box, IconButton } from '@mui/material';
import defaultUserThumbnail from '../../../assets/default_user_thumbnail.svg';
import profileAddIcon from '../../../assets/profile_add.svg';
import profileEditIcon from '../../../assets/profile_edit.svg';
import profileDeleteIcon from '../../../assets/profile_delete.svg';
import theme from '../../../theme';

const ProfileAvatar = ({
  src,
  alt,
  size = 48,
  isMyPage = true,
  onMenuOpen, // For MyPage: opens a menu
  onDelete, // For AdminUserPage: direct delete action
}) => {
  const iconButtonStyles = {
    position: 'absolute',
    bottom: '0',
    right: '0',
    padding: '0',
    width: '14px',
    height: '14px',
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Avatar
        src={src || defaultUserThumbnail}
        alt={alt}
        sx={{ width: size, height: size, border: `1px solid ${theme.palette.grey.line}` }}
      />
      {isMyPage ? (
        <IconButton onClick={onMenuOpen} sx={iconButtonStyles}>
          <Box
            component="img"
            src={src ? profileEditIcon : profileAddIcon}
            alt={src ? '프로필 이미지 수정' : '프로필 이미지 추가'}
            sx={{ width: '100%', height: '100%' }}
          />
        </IconButton>
      ) : (
        onDelete && (
          <IconButton onClick={onDelete} sx={iconButtonStyles}>
            <Box
              component="img"
              src={profileDeleteIcon}
              alt="프로필 이미지 삭제"
              sx={{ width: '100%', height: '100%' }}
            />
          </IconButton>
        )
      )}
    </Box>
  );
};

export default ProfileAvatar;
